export default "__VITE_ASSET__CfGueUEr__"